import moment from 'moment';
import 'moment-range';
import 'moment-timezone';

const DEFAULT_MAX_DAYS = 90;
const DEFAULT_MIN_MONTHS = 13;
const MAX_HOURLY_USAGE_DAYS = 30;
const MIN_HOURLY_USAGE_MONTHS = 1;
const HOURLY_ASSET_UTILIZATION = 'Hourly Asset Utilization';

export default function FormDateRangeController($scope) {
  'ngInject';

  let vm = this;
  let maxDaysInRange =
    $scope.reportName === HOURLY_ASSET_UTILIZATION ? MAX_HOURLY_USAGE_DAYS : DEFAULT_MAX_DAYS;

  vm.maxDaysRange = maxDaysInRange;
  vm.minDateInMonths =
    $scope.reportName === HOURLY_ASSET_UTILIZATION ? MIN_HOURLY_USAGE_MONTHS : DEFAULT_MIN_MONTHS;

  // Public Variables

  vm.dateOptions = {
    fromDate: {
      formatYear: 'yy',
      startingDay: 1,
      initDate: moment().subtract(1, 'days').toDate(),
      minDate: moment().subtract(vm.minDateInMonths, 'months').toDate(),
      maxDate: moment().subtract(1, 'days').toDate(),
    },
    toDate: {
      formatYear: 'yy',
      startingDay: 1,
      initDate: moment().toDate(),
      minDate: moment().subtract(vm.minDateInMonths, 'months').toDate(),
      maxDate: moment().toDate(),
    },
  };

  vm.isSelected = {};
  vm.isStartGreaterThanEnd = false;
  vm.isEndendLowerThanStart = false;
  vm.isExceededRange = false;

  vm.dateChanged = dateChanged;
  vm.endOnClick = endOnClick;
  vm.startOnClick = startOnClick;
  vm.endLowerThanStart = endLowerThanStart;
  vm.startGreaterThanEnd = startGreaterThanEnd;
  vm.endDateLowerThanMin = endDateLowerThanMin;
  vm.exceededRange = exceededRange;
  vm.greaterThanToday = greaterThanToday;
  vm.lessThanMinDate = lessThanMinDate;

  vm.$onInit = () => {
    refresh();
  };

  // Public Functions
  function dateChanged(val, fromPicker) {
    if (val) {
      let today = moment();
      let dateAfterDateRange = moment();

      if (fromPicker) {
        dateAfterDateRange = moment(val).add(maxDaysInRange, 'days');
      } else {
        dateAfterDateRange = moment(val).subtract(maxDaysInRange, 'days'); // allow from date
        vm.dateOptions.fromDate.initDate = dateAfterDateRange.toDate();
      }

      if (fromPicker) {
        // make sure the range between from and to date doesn't exceed today date or the allowed range
        if (moment(dateAfterDateRange.toDate()).isAfter(today.toDate())) {
          vm.dateOptions.toDate.maxDate = today.toDate();
          vm.dateOptions.toDate.initDate = today.toDate();
        } else {
          vm.dateOptions.toDate.maxDate = dateAfterDateRange.toDate();
          vm.dateOptions.toDate.initDate = dateAfterDateRange.toDate();
        }
        //when to date has been set up before from
        if ($scope.date.end) {
          if (moment($scope.date.end).isAfter(dateAfterDateRange.toDate())) {
            $scope.date.end = null;
            vm.maxDateRangeExceeded = true;
          }
        }
      }

      //more validations
      vm.exceededRange(maxDaysInRange);
      if ($scope.date.end) {
        vm.endLowerThanStart();
      }
      if ($scope.date.start) {
        vm.startGreaterThanEnd();
      }
    } else {
      vm.dateOptions.toDate.maxDate = moment().toDate();
      vm.dateOptions.toDate.initdate = moment().toDate();
    }
  }

  function endOnClick() {
    openEnd();
    vm.isSelected.toDate = false;
    vm.isSelected.fromDate = true;
  }

  function startOnClick() {
    openStart();
    vm.isSelected.toDate = true;
    vm.isSelected.fromDate = false;
  }

  function exceededRange(numMaximumDaysAllowed) {
    if (numMaximumDaysAllowed && $scope.date.end && $scope.date.start) {
      const range = moment.range($scope.date.start, $scope.date.end);
      const diff = range.diff('days');
      vm.isExceededRange = diff > numMaximumDaysAllowed;
      if (vm.isExceededRange) return;
    }
    if (vm.maxDateRangeExceeded) {
      vm.maxDateRangeExceeded = !vm.maxDateRangeExceeded;
    }
    vm.isExceededRange = vm.maxDateRangeExceeded;
  }

  function greaterThanToday(date) {
    return moment(date).isAfter(moment().endOf('day'));
  }

  function lessThanMinDate(date) {
    if (date && vm.dateOptions.fromDate.minDate) {
      // uses 'day' for granularity so that it does not compare teh time
      return moment(date).isBefore(vm.dateOptions.fromDate.minDate, 'day');
    }
  }

  function endLowerThanStart() {
    vm.isEndLowerThanStart = moment($scope.date.start).isAfter($scope.date.end, 'day');
  }

  function endDateLowerThanMin() {
    if (
      (($scope.date.end && $scope.reportForm.dt_EndDate.$error.dateGreaterThan) ||
        $scope.csvForm.dt_EndDate.$error.dateGreaterThan) &&
      vm.isSelected.fromDate
    ) {
      //ending 7 day period field
      return true;
    } else {
      return false;
    }
  }

  function startGreaterThanEnd() {
    if (
      $scope.date.start &&
      $scope.date.end &&
      moment($scope.date.start).isAfter($scope.date.end) &&
      vm.isSelected.toDate
    ) {
      vm.isStartGreaterThanEnd = true;
    } else {
      vm.isStartGreaterThanEnd = false;
    }
  }

  // Private Functions

  function refresh() {
    let minDate;
    //reset the end date when the templates are swapped or residual value interferes in the form validation
    $scope.date.end = null; // the scope value is defined in the parent controller

    for (let i = 0; i < $scope.parametersData.length; i++) {
      if ($scope.parametersData[i].name === 'dt_StartDate') {
        $scope.date.start = $scope.parametersData[i].defaultValues[0];
      } else if ($scope.parametersData[i].name === 'dt_EndDate') {
        $scope.date.end === $scope.parametersData[i].defaultValues[0];
      } else if ($scope.parametersData[i].name === 'date_PickRange') {
        minDate = $scope.parametersData[i].defaultValues[0];
        maxDaysInRange = parseInt(minDate);
      }
    }
  }

  function openEnd() {
    vm.endOpened = true;
  }

  function openStart() {
    vm.startOpened = true;
  }
}
